import { Scenario, ScenarioParameters, ScenarioStepParameter, TranslatedEmb, VisionStat } from '@wizeoo/akm-message-lib';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';
import { ViewData } from '../../model/view.data';
import { ScenarioVO as BaseScenarioVO, IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { Model } from '../../model/model';

/**
 * un scenario pour la vision
 */
@entity('wizeoo.allkeyme.scenario.message.Scenario', 'VISION')
export class ScenarioVO extends BaseScenarioVO implements IVo {
  
  constructor(model: Model, pSource?: Scenario) {
    super(model, pSource);
    this.initCode = this.code;
  }

  public get model(): Model {
    return this._model as Model;
  }

  // code domaine (root), technique
  public get domain(): string {
    return this._source.domain;
  }
  public set domain(value: string) {
    this._source.domain = value;
  }

  public get businessUnitCode(): string {
    // code de la BU
    return this._source.businessUnitCode;
  }
  public set businessUnitCode(value: string) {
    this._source.businessUnitCode = value;
  }

  @field('string')
  public set visionCode(visionCode: string) {
    this._source.visionCode = visionCode;
  }

  public get visionCode(): string {
    return this._source.visionCode;
  }

  // TODO : détecter les changements sur les sous-collections
  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu des lines
  public get maintenanceFlag(): string {
    return this._source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this._source.maintenanceFlag = value;
  }

  /**
   * code unique du scnar dans la vision (visionCode + # + UUID)
   */
  @field('string')
  public set code(value: string) {
    this._source.code = value;
  }
  public get code(): string {
    return this._source.code;
  }

  // Id technique
  public get id(): number {
    return this._source.id;
  }
  public set id(value: number) {
    this._source.id = value;
  }

  // UID technique
  public get uid(): string {
    return this._source.uid;
  }
  public set uid(value: string) {
    this._source.uid = value;
  }

  public get version(): number {
    // technique
    return this._source.version;
  }
  public set version(value: number) {
    this._source.version = value;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this.source.description = value;
  }
  public get description(): TranslatedEmb {
    return this.source.description;
  }

  /**
   * code du parent (step supérieur)
   */
  @field('string')
  public set parentCode(value: string) {
    this._source.parentCode = value;
  }
  public get parentCode(): string {
    return this._source.parentCode;
  }



  // configuration
  @field('string')
  public get parameters(): ScenarioParameters {
    if(!this._source.parameters) {
      this._source.parameters = new ScenarioParameters();
    }
    return this._source.parameters;
  }
  public set parameters(value: ScenarioParameters) {
      this._source.parameters = value;
  }


  public get color(): string {
    return this.parameters.color;
  }

  public set color(value: string) {
    this.parameters.color = value;
  }

  public get stepParameters(): ScenarioStepParameter[] {
    return this.parameters.stepParameters;
  }

  public set stepParameters(values: ScenarioStepParameter[]) {
    this.parameters.stepParameters = values;
  }

  public get operation(): string {
    return this.source.operation;
  }
  public set operation(value: string) {
    this.source.operation = value;
  }

  public get userMode(): boolean {
    return this.parameters.userMode;
  }

  public set userMode(value: boolean) {
    this.parameters.userMode = value;
  }

  public get owner(): string {
    return this.parameters.owner;
  }

  public set owner(value: string) {
    this.parameters.owner = value;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  public get enterpriseMode(): boolean {
    return !this.parameters.userMode;
  }

  /** Le style est-il persisté? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this._source.id > 0;
  }

  public initCode: string = null; // le code crée lors de l'initialisation. Pour renconstruction de l'arbre si changement



  private _parentVO: ScenarioVO = null;
  public get parentVO(): ScenarioVO {
    if(!this._parentVO) {
      this._parentVO = this.model.scenarioEngine.getScenario(this.visionCode, this.parentCode);
    }
    return this._parentVO;
  }

    /* ################################################
              gestion de la traduction
  ################################################ */

  public get isMain():boolean {
    return this.code === ViewData.DEFAULT_SCENARIO;
  }

  /**
   * Return translated label
   * @return string
   */
  public get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.code);
  }

  /**
   * Return translated label
   * @return string
   */
  public get trsDescription(): string {
    return this.model.localeEngine.translate(this.description);
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = this.model.localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  /**
   * Return translated label
   * @return string
   */
  public get parentTrsLabel(): string {
    if(this.parentVO) {
      return this.parentVO.trsLabel;
    }
    return '';
  }

  /**
   * Return translated label
   * @return string
   */
  public get parentTrsDescription(): string {
    if(this.parentVO) {
      return this.parentVO.trsDescription;
    }
    return '';
  }

  /** alimentation des statistiques pour la vue de génération */
  public stats: VisionStat;


}
